import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const ValueAdd = () => {
  const theme = useTheme();
  const oliveColor = theme.palette.brand?.altamiraOlive || '#2B3A1D';

  const items = [
    {
      title: 'Infraestructura Tecnológica Impecable',
      text: 'Medio dirigido por una Ingeniera de Software (CEO), con enfoque técnico, moderno y disruptivo para preservar la imagen premium del hotel.',
    },
    {
      title: 'Motor de Conversión',
      text: 'El TNO Digest transforma visibilidad en reservas mediante enlaces trazables y artículos con enfoque SEO de alta intención.',
    },
    {
      title: 'Mística y Cercanía',
      text: 'El hotel no es un cliente más: cuidamos su narrativa con calidez humana y rigor de ejecución para construir una alianza de largo plazo.',
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 'medium' }}
          gutterBottom
          color="primary"
          align="center"
        >
          5. Por qué TNO
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant="h4"
          gutterBottom
          align="center"
          color="primary"
        >
          El Diferencial para Altamira Village
        </Box>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              sx={{
                p: 2,
                height: '100%',
                borderRadius: 2,
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.mode === 'dark' ? 'action.hover' : 'grey.50',
                borderLeft: `5px solid ${oliveColor}`,
              }}
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <Typography variant="h6" gutterBottom fontWeight={700}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {item.text}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ValueAdd;
